import { defineLocalStore } from '@/utils/localStore'
import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import { cachedObject } from 'best-modules/utils'
import { handleAsync, setSnackbar } from 'best-modules/plugins'
import { helpers, required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { notifyValidation } from '@/utils/helpers'
import { incidentCreate } from '@/requests/incident'
import type { IncidentCreateCredentials } from '@/utils/types/incident'
import { useCan } from '@/composables/useCan'

export const {
  initLocalStore: initIncidentCreate,
  useLocalStore: useIncidentCreate,
} = defineLocalStore('incidentCreate', () => {
  const router = useRouter()
  const { can } = useCan()
  const credentials = cachedObject<IncidentCreateCredentials>({
    name: '',
    typeId: null,
    categoryId: null,
    occurredDate: null,
    detectedDate: null,
    priorityId: null,
  })

  const draftStatus = reactive({ name: 'Чернетка' })
  const rules = {
    name: { required },
    typeId: { required },
    categoryId: { required },
    priorityId: { required },
    detectedDate: {
      isAfterOccurredDate: helpers.withMessage(
        'Дата виявлення не може бути раніше дати виникнення',
        () => {
          if (!credentials.detectedDate || !credentials.occurredDate) {
            return true
          }

          return credentials.detectedDate >= credentials.occurredDate
        }
      ),
    },
  }
  const v$ = useVuelidate(rules, credentials)

  const createIncident = () => {
    if (!can('incidents.create')) return

    v$.value.$touch()
    if (v$.value.$invalid) {
      notifyValidation(v$.value, 'incidentCreate')
      return
    }

    return handleAsync('createIncident', async () => {
      const incident = await incidentCreate(credentials.$object)
      setSnackbar({
        color: 'success',
        text: 'Інцидент створено',
      })
      await router.push({
        name: 'incident-overview',
        params: { id: incident.id },
      })
    })
  }

  const cancel = () => {
    router.push({ name: 'incident-list' })
  }

  return {
    cancel,
    createIncident,
    credentials,
    draftStatus,
    v$,
  }
})
